var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-autocomplete',{attrs:{"id":_vm.id,"data":_vm.data,"placeholder":_vm.placeholder,"loading":_vm.isFetching,"value":_vm.value},on:{"typing":_vm.getAsyncData,"input":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }